import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { client } from "../../../config/ipfsConfig";
import { toast } from 'react-hot-toast';
import { collectionAdd, collectionDeploy, getCollectionDetailsById, updateCollectionDetailsById } from '../../../hooks/Collectionhook';
import { useSelector } from 'react-redux';
import useFullPageLoader from '../../../hooks/useFullPageLoader';
import { deleteCollectionDraft, getCollectionDraftsById, updateCollectionDraft } from '../../../hooks/DraftHook';

const DraftCollectionDetails = () => {
  useDocumentTitle('Create Collection');
  const [fileUrl, setFileUrl] = useState(null);
  const [type, setType] = useState(null);
  const [fileName, setFileName] = useState(null);

  const [formInput, updateFormInput] = useState({});
  const [gasLimitError, setGasLimitError] = useState('');
  // const [loader, showLoader, hideLoader] = useFullPageLoader();
  const walletAddress = localStorage.getItem("WalletAddress");
  const Navigate = useNavigate();
  const PROVIDER = useSelector((state) => state.valueFromHeader);
  const { id } = useParams();

  useEffect(() => {
    getCollectionDetailsById(id).then((data) => {
      if (data.status === 201) {
        console.log("data", data);
        
        setFileUrl(data.data.logo);
        updateFormInput({ name: data.data.name, gasLimit: data.data.gasLimit, symbol: data.data?.symbol, desc: data.data.description })
      }
    })
  }, [])

  async function onChange(e) {
    const file = e.target.files[0];
    setType(file.type.split('/')[0]);
    setFileName(file.name)

    try {
      const added = await client.add(file, {
        progress: (prog) => console.log(`received: ${prog}`),
      });
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;
      setFileUrl(url);
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  }

  async function handleChange(e) {
    updateFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    })
  }
  async function handleChangeOfGas(e) {
    const valueOfGas = e.target.value;
    if (Number(valueOfGas) <= 4999999) {
      setGasLimitError('Gas limit must be greater than or equal 5,000,000.');
    }
    else {
      setGasLimitError('');
      updateFormInput({
        ...formInput,
        gasLimit: e.target.value,
      })
    }


  }

  const CreateCollection = async () => {
    // showLoader();
    if (!walletAddress) {
      toast.error("Please Connect Wallet First")
    }
    else {
      await DeployCollection();
      setTimeout(() => {
        // hideLoader()
      }, 2000);
    }
  };

  const DeployCollection = async () => {
    const body = {
      walletAddress: walletAddress,
      gasLimit: formInput.gasLimit,
      name: formInput.name,
      symbol: formInput.symbol
      
    };

    collectionDeploy(body).then(async (data) => {
      const collectionData = data.data
      const signer = await PROVIDER.getSigner(walletAddress);
      const sentTx = await signer.sendTransaction(collectionData);
      const reciept = await sentTx.wait();
      await Collection(reciept.contractAddress);
    })
  }

  const Collection = async (contractAddress) => {
    try {
      const data = JSON.stringify({
        collectionAddress: contractAddress,
        walletAddress: walletAddress,
        name: formInput.name,
        symbol: formInput.symbol,
        description: formInput.desc,
        isDraft: false
      });

      collectionAdd(data).then((value) => {
        if (value.status === 201) {
          toast.success("Create Collection Successfully.");
          DeleteDraftCollection()
          Navigate("/upload")
        }
      })
    } catch (error) {
      console.error("Error calling function:", error);
    }
  };
  const closeButton = () => {
    setFileUrl(null)
    setFileName(null)
  }

  const DraftCollection = async () => {
    try {
      const data = JSON.stringify({
        // contractAddress: contractAddress,
      
        name: formInput.name,
        symbol: formInput.symbol,
        description: formInput.desc,
      });

      updateCollectionDetailsById(id, data).then((data) => {
        if (data.status === 201) {
          toast.success("Save Collection Draft Successfully.");
          Navigate("/profile")
        }
      })
    } catch (error) {
      console.error("Error calling function:", error);
    }
  }
  const DeleteDraftCollection = async () => {
    try {


      deleteCollectionDraft(id).then((data) => {
        if (data.status === 201) {
          toast.success("Delete Collection Draft Successfully.");
          Navigate("/profile")
        }
      })
    } catch (error) {
      console.error("Error calling function:", error);
    }
  }

  return (
    <div>
      <div className="hero__upload">
        <div className="container">
          <h1 className="title">Update Collection</h1>
        </div>
      </div>
      <div className="container">
        <div className="box in__upload mb-120" style={{ position: "relative" }}>
          <div className="row">
            <div className="col-lg-6">
              <div className="left__part space-y-40 md:mb-20 upload_file" style={{ minHeight: "50vh" }}>
                <div className="space-y-20">
                  {/* {fileUrl && (
                    <div id="upload_file_close_button" className="closeButton" style={{ cursor: "pointer" }} onClick={closeButton}>
                      X
                    </div>
                  )} */}
                  {/* {type === "image" && */}
                    <div>
                      {fileUrl && (
                        <img src={fileUrl} />
                      )}
                    </div>
                     
                  {/* //   type === "video" &&
                  //   <div>
                  //     {fileUrl && (
                  //       <video src={fileUrl} />
                  //     )}
                  //   </div>

                  // } */}
                  {fileUrl ? "" : <p className="color_text">Max size: 50MB <br />
                    JPG, PNG, GIF, SVG, MP4</p>}
                  {/* {assetError && <div className="error-message">{assetError}</div>} */}
                  {fileName && <div style={{ color: "black" }}>{fileName}</div>}

                </div>
                {fileUrl ? "" : (
                  <div className="space-y-20">
                    <p className="color_text">or choose a file</p>
                    <div id="browse files">
                      <Link to="#" className="btn btn-white">
                        Browse files
                      </Link>
                      <input type="file" onChange={onChange} />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group space-y-10">
                <div className="space-y-20">
                  <div className="space-y-10">
                    <span className="nameInput">Name</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Collection Name"
                      name='name'
                      onChange={handleChange}
                      defaultValue={formInput ? formInput.name : "Name"}

                    />
                  </div>
                  <div className="space-y-10">
                    <span className="variationInput">Gas Limit</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Gas Limit"
                      name='gasLimit'
                      onChange={handleChangeOfGas}
                      defaultValue={formInput ? formInput.gasLimit : "gasLimit"}

                    />
                    {gasLimitError && <div style={{ color: 'red' }}>{gasLimitError}</div>}
                  </div>
                  <div className="space-y-10">
                    <span className="variationInput">Symbol</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Symbol"
                      name='symbol'
                      autoCapitalize='true'
                      style={{ textTransform: "uppercase" }}
                      onChange={handleChange}
                      defaultValue={formInput ? formInput.symbol : "Symbol"}

                    />
                  </div>
                  <div className="space-y-10">
                    <span className="nameInput">
                      Description
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e. g. `Dtoc design art`"
                      name='desc'
                      onChange={handleChange}
                      defaultValue={formInput ? formInput.desc : "Description"}

                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row content justify-content-between mb-20_reset mt-20" style={{ position: "abslute", bottom: "0px", right: "0px" }}>
            <div className="col-md-auto col-12 mb-20">
              <div className="space-x-10">
                <Link
                  to="/marketplace"
                  className="btn btn-white
						others_btn">
                  Cancel
                </Link>
              </div>
            </div>
            <div className="col-md-auto col-12 mb-20">
              <div
                onClick={() => DraftCollection()}
                className="btn btn-grad
					btn_create mx-3">
                Update Draft Collection
              </div>
              {/* <div
                onClick={() => DeleteDraftCollection()}
                className="btn btn-grad
					btn_create mx-3">
                Delete Draft Collection
              </div> */}
              <div
                onClick={() => CreateCollection()}
                className="btn btn-grad
					btn_create">
                Collection to Market
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {loader} */}
    </div>
  );
};

export default DraftCollectionDetails;
